const paymentConfig = {
  typeList: [
    {
      type: 8,
      title: 'MIXPAY',
      mIcon: require('@/assets/images/shop/mobile-mixpay.png'),
      pcIcon: require('@/assets/images/shop/pc-mixpay.png'),
      product: ['pm-diamond1', 'pm-diamond3', 'pm-diamond580', 'pm-diamond1850', 'pm-diamond3000', 'pm-diamond6200', 'pm-diamond19k', 'pm-diamond32k', 'pm-diamond64k', 'pm-diamond130k', 'pm-diamond330k'],
      isDev: false
    }
  ]
}
export default paymentConfig



// WEBPACK FOOTER //
// ./src/util/payment.js